module.exports = __webpack_public_path__ + "img/asset-03.c94c9acd.svg";